import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type {
  AddPropertyChargeDto,
  AdjustPropertyChargeDto,
  PropertyChargeDto,
  PropertyChargeItemDto,
  PropertyChargePaginationDto,
} from '~/swagger/portal/Api';
import type { ApiFilter } from '~/types/apiFilters';

const BASE_URL = '/api/properties';
export class PropertiesBillsRepository extends BaseRestRepository {
  public async createPropertyBill(propertyId: string, data: AddPropertyChargeDto): Promise<PropertyChargeItemDto> {
    const url = `${BASE_URL}/${propertyId}/charges`;
    const response = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify(data) });
    return await this.getJsonResponse(response);
  }

  public async getPropertyBills(propertyId: string, filters: ApiFilter): Promise<PropertyChargePaginationDto> {
    const url = `${BASE_URL}/${propertyId}/charges`;
    const response = await this.fetchWithAuth(urlWithQuery(url, filters));
    return this.getJsonResponse(response);
  }

  public async getPropertyBill(propertyId: string, billId: string): Promise<PropertyChargeDto> {
    const url = `${BASE_URL}/${propertyId}/charges/${billId}`;
    const response = await this.fetchWithAuth(url, { method: 'GET' });
    return this.getJsonResponse(response);
  }

  public async updatePropertyBill(propertyId: string, billId: string, data: AdjustPropertyChargeDto): Promise<PropertyChargeItemDto> {
    const url = `${BASE_URL}/${propertyId}/charges/${billId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async deletePropertyBill(propertyId: string, billId: string) {
    const url = `${BASE_URL}/${propertyId}/charges/${billId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
